/**
 * /print — deep-link wrapper around PrintWindowView (the main path is in-app
 * print tabs via PrintTabOpener).
 */
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PrintWindowView } from '@/runtime/print/PrintWindowView';
import type { PrintWindowDescriptor } from '@/runtime/print/openPrintWindow';

export default function PrintWindowPage() {
  const [params] = useSearchParams();
  const descriptor: PrintWindowDescriptor = useMemo(
    () => ({
      connectionId: params.get('connection_id') || '',
      tableName: params.get('table_name') || '',
      instanceId: params.get('instance_id') || '',
      layoutNodeId: params.get('layout_node_id') || '',
    }),
    [params],
  );
  return (
    <PrintWindowView
      descriptor={descriptor}
      onTitleChange={(title) => {
        document.title = title;
      }}
    />
  );
}
